import script from "./CellEditMenuWrapper.vue?vue&type=script&setup=true&lang=ts"
export * from "./CellEditMenuWrapper.vue?vue&type=script&setup=true&lang=ts"

import "./CellEditMenuWrapper.vue?vue&type=style&index=0&id=3f20687a&lang=css"

const __exports__ = script;

export default __exports__